import React, { useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

const Notification = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // Notification will disappear after 3 seconds

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed top-4 left-0 right-0 mx-auto bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2 justify-center opacity-0 animate-fadeIn max-w-xs z-50">
      <FaCheckCircle />
      <span>{message}</span>
    </div>
  );
};

export default Notification;
